module.exports = __webpack_public_path__ + "static/img/iconshipinlan_shengyin_guanbi_16_bai.d4133b95.png";